import { init } from '@sentry/react';
import config from './config';

if (!['local', 'localQa', 'localProd'].includes(config.env)) {
  init({
    dsn: 'https://86f80df6a6444552b0dc2e720788777a@o347535.ingest.us.sentry.io/6097156',
    environment: config.env,
    sampleRate: 0.1,
    tracesSampleRate: 0,
  });
}
